import type { MessageKey, Translator } from "~/i18n";

import type { WfNodeData, WfNodeKind } from "./WorkflowCanvas";
import { defaultLoopRoutes } from "./workflowRoutes";

export function canvasKindLabel(kind: WfNodeKind, t: Translator): string {
  return t(`workflows.canvas.kind.${kind}` as MessageKey);
}

export function defaultNodeData(kind: WfNodeKind, t: Translator): WfNodeData {
  const label = canvasKindLabel(kind, t);
  return kind === "app"
    ? { kind, label, appSlug: "", steps: [""] }
    : kind === "browser" || kind === "cloudBrowser" || kind === "computer"
      ? { kind, label, text: "" }
      : kind === "vault"
        ? { kind, label, vaultIds: [] }
        : kind === "decision"
          ? {
              // A new decision arrives AS an A-or-B with two wired-up exits. It used to arrive as
              // the old single-exit gate, so the branching was buried behind a checkbox in the
              // inspector and "where is the if/else?" had no answer on the canvas.
              kind,
              label,
              text: "",
              routes: defaultLoopRoutes(
                t("workflows.canvas.routes.moreDefault"),
                t("workflows.canvas.routes.doneDefault"),
              ),
              maxPasses: 100,
            }
          : kind === "foreach"
            ? { kind, label, concurrency: 3, staggerSeconds: 20, onFail: "skip" }
            : kind === "output"
              ? { kind, label, text: "" }
              : { kind, label: t("workflows.canvas.defaultNewTrigger") };
}

export function outputChannels(t: Translator): ReadonlyArray<{ value: string; label: string }> {
  return [
    { value: "", label: t("workflows.canvas.channel.any") },
    { value: "personal-whatsapp", label: t("workflows.canvas.channel.personalWhatsapp") },
    { value: "whatsapp", label: t("workflows.canvas.channel.whatsapp") },
    { value: "telegram", label: t("workflows.canvas.channel.telegram") },
    { value: "slack", label: t("workflows.canvas.channel.slack") },
    { value: "discord", label: t("workflows.canvas.channel.discord") },
    { value: "chat", label: t("workflows.canvas.channel.chat") },
  ];
}
